import React from 'react';

const Contacts = () => {
  return (
    <div className="min-h-screen bg-background p-8">
      <div className="max-w-7xl mx-auto">
        <h1 className="text-3xl font-bold text-text mb-8">
          Contacts
        </h1>
        <div className="card p-8">
          <p className="text-gray-600">
            Gestion des contacts en cours de développement
          </p>
        </div>
      </div>
    </div>
  );
};

export default Contacts;









